import { SVGAttributes } from "react";

export const TEXTS = {
    ADD_A_NEW_UPI: "ADD A NEW UPI",
    ADD_NEW_UPI_ID: "Add New UPI ID",
    ADD_UPI_SUB_CONTENT: "You must have a Virtual Payment Address",
    INVALID_UPI_TEXT: "Invalid Upi Id",
    NEW_UPI_PLACEHOLDER_TEXT: "Enter your UPI ID",
    OFFER: "OFFER",
    PAY_X: "Pay \u20B9{0}",
    RETRY_WITH_UPI: "Retry with UPI",
    SECURELY_UPI: "Securely save VPA for future use",
    SOMETHING_WENT_WRONG: "Oops!! Something went wrong",
    UPI_DECLINED_HEADER: "UPI request declined",
    UPI_DECLINED_MESSAGE: "Your payment request for \u20B9{0} using UPI sent to your bank app was declined",
    UPI_TIMED_OUT_HEADER: "UPI request timed out",
    UPI_TIMED_OUT_MESSAGE: "Your payment request for \u20B9{0} using UPI sent to your bank app was timed out",
    UPI_TIMER_OPEN_APP_MESSAGE: "Open your UPI app to approve the payment request from Swiggy.",
    VERIFY_AND_PAY: "Verify and Pay",
    X_MORE_UPI: "{0} more saved UPI",
    X_MORE_UPIS: "{0} more saved UPIs",
    YOUR_UPI_ADDRESS: "YOUR UPI ADDRESS",
    CANCEL_PAYMENT: "Cancel payment",
    YES_CANCEL: "Yes, Cancel",
    NO: "No",
    NOTE: "Note: ",
};

export const UPI_HOW_IT_WORKS = {
    TITLE: "How UPI works?",
    BUTTON_COLOR: "#ff5200",
    CONTENT: [
        {
            ICON: "OpenUPIapp_qz9rc0",
            TEXT: "Open UPI linked app on your phone or tap on the notification received for the same in SMS",
        },
        {
            ICON: "CheckRequests_lv3fms",
            TEXT: "Check the collect request from Swiggy in pending transactions in linked UPI app",
        },
        {
            ICON: "CompleteThePayment_k2vgmv",
            TEXT: "Complete the payment by accepting the request and entering UPI pin",
        },
    ],
};

export const UPI_TIMER_CONTENT = {
    HEADING: "Open your UPI app to approve the payment request from Swiggy.",
    TITLE: "Please approve the payment request before it times out",
    META: "Do not hit back button until the transaction is complete.",
};

export const UPI_TIMER_CONTENT_V4 = {
    TITLE: "Open your UPI app to approve the payment request before the timer runs out",
    META: "Do not hit back button or close this screen until the transaction is complete",
};

export const UPI_PAYMENT_ALERT = {
    TITLE: "Are you sure you want to cancel payment?",
    MESSAGE:
        "On cancelling the payment, the payment request will get cancelled only if you have not completed the payment on UPI Bank app.",
    INFO: "To Pay ₹{0}",
    SUB_INFO: "({0} Items)",
    PRIMARY_ACTION_NAME: "Yes, cancel",
    SECONDARY_ACTION_NAME: "No",
};

export const UPI_PAYMENT_ALERT_V4 = {
    TITLE: "Are you sure you want to cancel the payment?",
    MESSAGE: "The payment request will get cancelled as we are confirming your payment status.",
    INFO: "PAYMENT OF ₹{0}",
    SUB_INFO: " \u2022 FOR {0} ITEMS",
    PRIMARY_ACTION_NAME: "Yes, cancel",
    SECONDARY_ACTION_NAME: "No",
};

export const UPI_ICON_WIDTH = 48;

export const SECS_PER_MINUTE = 60;
export const MILLI_SECS_PER_SEC = 1000;
export const PERCENTAGE = {
    FIFTY: 50,
    HUNDRED: 100,
    SEVENTY_FIVE: 75,
};

export const TIMER_DEFAULT_PROPS = {
    TRAIL_COLOR: "#d9d9d9",
    STROKELIKE_CAP: "butt" as SVGAttributes<SVGImageElement>["strokeLinecap"],
    STROKE_WIDTH: 10,
    SIZE: 120,
    ROTATION: "clockwise",
};

export const TIMER_DEFAULT_PROPS_V4 = {
    TRAIL_COLOR: "#d9d9d9",
    STROKELIKE_CAP: "round" as SVGAttributes<SVGImageElement>["strokeLinecap"],
    STROKE_WIDTH: 7,
    SIZE: 140,
    CONTAINER_SIZE: 156,
    ROTATION: "anti-clockwise",
    NUMBER_OF_STROKES: 60,
};

export const UPI_TIMER_COLORS = [
    { colorCode: "#60b246", duration: 0.8 },
    { colorCode: "#ff5200", duration: 0.1 },
    { colorCode: "#fa4a5b", duration: 0.1 },
];

export const UPI_TIMER_COLORS_V4 = [
    { colorCode: "#1BA672", duration: 0.5 },
    { colorCode: "#FFB608", duration: 0.25 },
    { colorCode: "#E53554", duration: 0.25 },
];

export const THIRD_PARTY_UPI_INTENT = "third.party";

export const PAY_VIA = "Pay Via";

export const UPI_BOTTOM_ICON_HEIGHT = 32;
export const UPI_BOTTOM_ICON_WIDTH = 64;
